import * as React from "react";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkText } from "uitk-react-text";

export const InfoDialog = ({
  infoText,
  closeDialog,
  buttonText
}: {
  infoText?: string;
  closeDialog: () => void;
  buttonText: string;
}) => {
  return (
    <UitkDialog className="uitk-scroll-vertical">
      <UitkDialogContent>
        <UitkText size={300}>
          {infoText?.split("\n").map((value, index) => (
            <p key={index}>{value}</p>
          ))}
        </UitkText>
      </UitkDialogContent>
      <UitkDialogFooter
        buttonOne={{
          onClick: closeDialog,
          text: buttonText,
          type: "tertiary"
        }}
      />
    </UitkDialog>
  );
};
